import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Packages from "./packages.vue"
import DataFilter from "./DataFilter.vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'generalForm',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Packages),
    _createVNode(DataFilter)
  ], 64))
}
}

})